import React from "react";
import { useNavigate } from "react-router-dom";
import MOCK_MODULES from "../../../mockData/mockModuleData";

const OnlineMods = () => {
  const navigate = useNavigate();

  const handleRowClick = (workOrder) => {
    // Navigate to Module Metrics page with workOrder as URL param
    navigate(`/module-metrics?workOrder=${encodeURIComponent(workOrder)}`);
  };

  return (
    <>
      <p className="modal-description">
        Units currently on physical line stations
      </p>

      <div className="modal-section modal-section--scroll">
        <h3>Active Line Items</h3>
        <div className="modal-table-scroll allow-x-scroll">
          <table className="modal-table modal-table--clickable">
            <thead>
              <tr>
                <th>Property</th>
                <th>Online Date</th>
                <th>Work Order</th>
                <th>Item Number</th>
                <th>Batch Number</th>
                <th>SQFT</th>
              </tr>
            </thead>
            <tbody>
              {MOCK_MODULES.map((mod) => (
                <tr
                  key={mod.workOrder}
                  onClick={() => handleRowClick(mod.workOrder)}
                  className="modal-table-row--clickable"
                  title="Click to view module details"
                >
                  <td>{mod.property}</td>
                  <td>{mod.onlineDate}</td>
                  <td>{mod.workOrder}</td>
                  <td>{mod.itemNumber}</td>
                  <td>{mod.batchNumber}</td>
                  <td>{mod.sqft.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default OnlineMods;
